// @flow
import React from 'react';
import styles from './Note.scss';


type Props = {
  footnotes: Object,
  value: string,
}

const Note = ({ footnotes, value }: Props) => (footnotes && footnotes[value]
  ? <sup className={styles.fn}>{footnotes[value].index}</sup>
  : null
);

export default Note;
